/**
 * Framework Templates — predefined zone layouts for brainstorm canvases
 */

const ZONE_W = 560;
const ZONE_H = 700;
const GAP = 40;

export const FRAMEWORK_TEMPLATES = {
  decision_making: {
    name: 'Decision Making',
    zones: [
      { id: 'zone_challenge', label: 'Challenge', color: '#DBEAFE', description: 'Define the problem', x: 0, y: 0 },
      { id: 'zone_data', label: 'Data', color: '#D1FAE5', description: 'Gather information', x: ZONE_W + GAP, y: 0 },
      { id: 'zone_options', label: 'Options', color: '#FEF3C7', description: 'Generate alternatives', x: (ZONE_W + GAP) * 2, y: 0 },
      { id: 'zone_analysis', label: 'Analysis', color: '#FDE68A', description: 'Evaluate options', x: (ZONE_W + GAP) * 3, y: 0 },
      { id: 'zone_decision', label: 'Decision', color: '#E0E7FF', description: 'Choose and commit', x: (ZONE_W + GAP) * 4, y: 0 },
    ],
  },
  swot: {
    name: 'SWOT Analysis',
    zones: [
      { id: 'zone_strengths', label: 'Strengths', color: '#D1FAE5', description: 'Internal positives', x: 0, y: 0 },
      { id: 'zone_weaknesses', label: 'Weaknesses', color: '#FEE2E2', description: 'Internal negatives', x: ZONE_W + GAP, y: 0 },
      { id: 'zone_opportunities', label: 'Opportunities', color: '#DBEAFE', description: 'External positives', x: 0, y: ZONE_H + GAP },
      { id: 'zone_threats', label: 'Threats', color: '#FEF3C7', description: 'External negatives', x: ZONE_W + GAP, y: ZONE_H + GAP },
    ],
  },
  retrospective: {
    name: 'Retrospective',
    zones: [
      { id: 'zone_went_well', label: 'What Went Well', color: '#D1FAE5', description: 'Celebrate successes', x: 0, y: 0 },
      { id: 'zone_didnt_go_well', label: "What Didn't", color: '#FEE2E2', description: 'Identify problems', x: ZONE_W + GAP, y: 0 },
      { id: 'zone_actions', label: 'Action Items', color: '#DBEAFE', description: 'Next steps', x: (ZONE_W + GAP) * 2, y: 0 },
    ],
  },
  lean_canvas: {
    name: 'Lean Canvas',
    zones: [
      { id: 'zone_problem', label: 'Problem', color: '#FEE2E2', description: 'Top 3 problems', x: 0, y: 0 },
      { id: 'zone_solution', label: 'Solution', color: '#D1FAE5', description: 'Top 3 features', x: ZONE_W + GAP, y: 0 },
      { id: 'zone_metrics', label: 'Key Metrics', color: '#DBEAFE', description: 'Measure success', x: (ZONE_W + GAP) * 2, y: 0 },
      { id: 'zone_value', label: 'Value Proposition', color: '#FEF3C7', description: 'Unique difference', x: (ZONE_W + GAP) * 3, y: 0 },
      { id: 'zone_channels', label: 'Channels', color: '#E0E7FF', description: 'Path to customers', x: 0, y: ZONE_H + GAP },
      { id: 'zone_revenue', label: 'Revenue', color: '#D1FAE5', description: 'Revenue streams', x: ZONE_W + GAP, y: ZONE_H + GAP },
      { id: 'zone_cost', label: 'Cost Structure', color: '#FEE2E2', description: 'Fixed & variable costs', x: (ZONE_W + GAP) * 2, y: ZONE_H + GAP },
      { id: 'zone_advantage', label: 'Unfair Advantage', color: '#FDE68A', description: 'Hard to copy', x: (ZONE_W + GAP) * 3, y: ZONE_H + GAP },
      { id: 'zone_customers', label: 'Customer Segments', color: '#E0E7FF', description: 'Target customers', x: (ZONE_W + GAP) * 4, y: 0, h: ZONE_H * 2 + GAP },
    ],
  },
  blank: {
    name: 'Blank Canvas',
    zones: [],
  },
};

export const ZONE_WIDTH = ZONE_W;
export const ZONE_HEIGHT = ZONE_H;

export function buildZoneNodes(templateId) {
  const template = FRAMEWORK_TEMPLATES[templateId] || FRAMEWORK_TEMPLATES.blank;
  return template.zones.map(z => ({
    id: z.id,
    type: 'zone',
    position: { x: z.x, y: z.y },
    data: { label: z.label, color: z.color, description: z.description },
    style: { width: ZONE_W, height: z.h || ZONE_H },
    draggable: false,
    selectable: false,
  }));
}
